import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {
  FirstLoginHandler,
  TwoFactorHandler,
  NavigationHandler,
  LoginHandler,
} from '../login/login-handler';

@Injectable({
  providedIn: 'root',
})
export class LoginHandlerFactory {
  constructor(private router: Router) {}

  create(): LoginHandler {
    const firstLogin = new FirstLoginHandler();
    const twoFactor = new TwoFactorHandler();
    const navigation = new NavigationHandler(this.router);

    firstLogin.setNext(twoFactor).setNext(navigation);
    return firstLogin;
  }
}
